<template>
  <div class="Nav white">
    <div class="word">
      <nav class="nav_div">
        <div class="img" @click="homePage">
          <img src="@/assets/images/logoT.png" alt="" />
        </div>
        <div class="nav_ul">
          <div
            class="nav_li_text flex_center selection"
            @click="homePage"
            :class="index == 0 ? 'this' : ''"
          >
            {{ $t("nav.home") }}
          </div>
          <div
            class="nav_li_text flex_center"
            @click="memberCenter"
            :class="index == 2 ? 'this' : ''"
          >
            {{ $t("nav.menberCenter") }}
          </div>
          <div
            class="nav_li_text flex_center"
            @click="product"
            :class="index == 1 ? 'this' : ''"
          >
            {{ $t("nav.proCenter") }}
          </div>
          <div
            class="nav_li_text flex_center"
            :class="index == 3 ? 'this' : ''"
            @click="customizedService"
          >
            {{ $t("nav.service") }}
          </div>
          <div
            class="nav_li_text flex_center"
            @click="share"
            :class="index == 4 ? 'this' : ''"
          >
            {{ $t("nav.share") }}
          </div>
          <div
            class="nav_li_text flex_center"
            @click="services"
            :class="index == 5 ? 'this' : ''"
          >
            {{ $t("nav.afterSale") }}
          </div>
          <div
            class="nav_li_text flex_center"
            @click="abtUs"
            :class="index == 6 ? 'this' : ''"
          >
            {{ $t("nav.aboutUS") }}
          </div>
        </div>
      </nav>
    </div>
  </div>
</template>

<script>
export default {
  name: "Nav",
  data() {
    return {
      index: 0,
    };
  },
  props: {},
  methods: {
    homePage() {
      this.$router.push("/");
      this.index = 0;
    },
    memberCenter() {
      this.$router.push("/membercenter");
      this.index = 1;
    },
    product() {
      this.index = 2;
      this.$router.push("/goodsCenter");
    },
    abtUs() {
      this.$router.push("/aboutUs");
      this.index = 6;
    },
    services() {
      this.$router.push("/service");
      this.index = 5;
    },
    share() {
      this.$router.push("/tgshare");
      this.index = 4;
    },
    customizedService() {
      this.$router.push("/customized/apply");
      this.index = 3;
    },
  },
  mounted() {
    this.$route.path.substring(1).toUpperCase() != "GOODSCENTER"
      ? (this.index = 2)
      : this.$route.path.substring(1).toUpperCase() == "MEMBERCENTER"
      ? (this.index = 1)
      : this.$route.path.substring(1).toUpperCase() == "CUSTOMIZED/APPLY"
      ? (this.index = 3)
      : this.$route.path.substring(1).toUpperCase() == "TGSHARE"
      ? (this.index = 4)
      : this.$route.path.substring(1).toUpperCase() == "ABOUTUS"
      ? (this.index = 5)
      : (this.index = 0);
  },
};
</script>

<style scoped>
.white {
  background: #fff;
  box-shadow: 0 0 12px rgba(0, 0, 0, 0.2);
}

.nav_div {
  height: 100px;
  background: #fff;
}
.nav_ul {
  min-width: 1000px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-left: 12px;
}

.nav_ul,
.nav_div {
  display: flex;
  align-items: center;
}

.img {
  height: 80px;
}
.img > img {
  height: 100%;
}

.nav_div .nav_ul .nav_li_text {
  color: #000;
}

.nav_div .nav_ul .nav_li_text:hover {
  color: #0090ff;
}

.nav_div .nav_ul .nav_li_text.this {
  color: #0090ff;
}
</style>



// WEBPACK FOOTER //
// src/components/assembly/WhiteNav.vue